import { useCallback, useEffect, useRef } from 'react';
import { Auth0Provider } from "@auth0/auth0-react";
import { NavBar } from 'components/molecules';
import { useOnBoardingGs1 } from 'partner/_hooks';
import { getAuthConfig } from 'partner/utilities';

const providerConfig = {
  domain: getAuthConfig.domain,
  clientId: getAuthConfig.clientId,
  onRedirectCallback: () => { },
  authorizationParams: {
    redirect_uri: `${window.location.origin}/partner/gs1/auth0`,
    audience: getAuthConfig.audience
  },
};
const VendorLayout = ({ children }) => {
  const initialized = useRef(null);
  const { fetchLookAndFeel, lookAndFeel } = useOnBoardingGs1();


  const init = useCallback(() => {
    fetchLookAndFeel();
  }, [fetchLookAndFeel]);

  useEffect(() => {
    if (!initialized?.current) {
      init();
    }
  }, [init]);

  return (
    <Auth0Provider
      {...providerConfig}
      cacheLocation='localstorage'
      useRefreshTokens={true}
    >
      <div className="l-vendor min-h-[100%] min-w-[100%] flex flex-wrap flex-col max-w-[550px]">
        <div className="min-w-[100%] shrink">
          <NavBar 
            bgColor={lookAndFeel?.navbar.solid}
            color={lookAndFeel?.navbar?.text}
            logo={lookAndFeel?.navbar?.logo}
            shadow={true}
          />
        </div>
        <div className="container mx-auto flex flex-auto flex-wrap p-5 flex-row">
          <div className="mx-auto sm:w-2/3 md:w-3/5 lg:w-5/12 max-w-[550px] m-0 p-3 pt-10">
            {children}
          </div>
        </div>
      </div>
    </Auth0Provider>
  );
};

export default VendorLayout;
